import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  message,
  Tree,
} from "antd";
import MiCompAPI from "../../../util/api";
class EditRoleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      selectedmenuRowKeys: [],
      originalRows: [],
      roleName: "",
      menus: [],
      title: this.props.role_id!== 0 ? "Edit Role" : "Create Role",
      searchText: "",
    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.api.invoke(
      "GetAllMenus",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            this.setState({
              menus: data.data,
              loading: false,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined
    );
    if (this.props.role_id!== 0) {
      this.api.invoke(
        "GetUserRoleById/" +
        this.props.role_id,
        "get",
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              this.setState({
                roleName: data.data.userRoleName
              })
            } else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
          }
        },
        undefined
      );
    }
    this.api.invoke(
      "getMenuPermissionByRoleID/" +
      this.props.role_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              selectedmenuRowKeys: data.data.map((x) => {
                return x.id.toString();
              }),
              originalRows: data.data.map((x) => {
                return x.id.toString();
              }),
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined
    );
  }
  handleCheckboxChange = (selectedRowKeys) => {
    this.setState({
      selectedRowKeys,
    });
  };
  handleSelectChange = (val, operation_id) => {
    this.setState({
      scopeMap: {
        ...this.state.scopeMap,
        [operation_id]: val,
      },
    });
  };
  handleChange = (e) => {
    this.setState({
      roleName: e.target.value,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.roleName !== "") {
      this.setState(
        {
          loading: true,
        },
        () => {
          const {
            roleName,
            originalRoleName,
            originalRows,
            selectedmenuRowKeys,
          } = this.state;
          message.loading("Editing Role. Please wait...", 0);
          if (
            roleName === originalRoleName &&
            originalRows === selectedmenuRowKeys
          ) {
            message.destroy();
            message.error("No changes! Please try with new values.",5);
          } else {
            let formData = {
              roleName: roleName,
              id: this.props.role_id,
              menuIds: this.state.selectedmenuRowKeys.map((x) => {
                return parseInt(x);
              }),
            };
           this.props.submitHandler(formData);
          }
        }
      );
    } else {
      message.error("Role name cannot be empty",5);
    }
  };
  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };
  onCheck = (checkedKeys) => {
    this.setState({
      selectedmenuRowKeys: checkedKeys,
    });
  };
  render() {
    const { selectedmenuRowKeys } = this.state;
    return (
              <Row>
                <Col md={8} sm={24}>
                  <p className="mi_table_title">{this.state.title}</p>
                </Col>
                <Col span={24} style={{ padding: 5, marginBottom: 20 }}>
                  <Row>
                    <Col span={24}>
                      <input className="mi_input_profile mi_input_profile1"
                        value={this.state.roleName}
                        onChange={this.handleChange}
                        required={false}
                        placeholder="Enter new role name"
                        style={{ marginLeft: 20 }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={24}>
                  <Tree
                    checkable
                    checkedKeys={selectedmenuRowKeys}
                    onCheck={this.onCheck}
                    treeData={this.state.menus}
                  />
                </Col>
                <Col span={24} style={{ marginTop: "25px" }}>
                  <Row >
                    <Col span={12}>
                      <Button
                        type="primary"
                        className="submit-button"
                        onClick={() => this.props.closeRole()}
                        name="editRole"
                      >
                        Back
                    </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        style={{ float: "right" }}
                        type="primary"
                        className="submit-button"
                        onClick={this.handleSubmit}
                        name="editRole"
                      >
                        Save
                    </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
    );
  }
}
export default EditRoleView;
